module.exports = __webpack_public_path__ + "img/websiteQrCode.svg";